import { useState } from 'react';
import { shipTruck, type ShipHead } from './logistics-api';

// Отправка машины на КПП: что и сколько грузим именно на эту машину (разбивка партии
// по рейсам) + идентификация (номер авто, водитель/перевозчик). Погруженное = отгруженное.
export function TruckModal({
  ship,
  onClose,
  onDone,
}: {
  ship: ShipHead;
  onClose: () => void;
  onDone: () => void;
}) {
  const rows = ship.items.map((it) => ({ ...it, rem: it.qty_total - it.qty_shipped }));
  const [plate, setPlate] = useState('');
  const [driver, setDriver] = useState('');
  // По умолчанию — весь остаток по каждой позиции (частый случай «догружаем всё»).
  const [qty, setQty] = useState<Record<number, string>>(
    Object.fromEntries(rows.map((r) => [r.id, String(r.rem)])),
  );
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);

  const val = (id: number, rem: number) =>
    Math.max(0, Math.min(Math.round(Number(qty[id]) || 0), rem));
  const totalLoad = rows.reduce((s, r) => s + val(r.id, r.rem), 0);

  async function submit() {
    const lines = rows
      .map((r) => ({ itemId: r.id, qty: val(r.id, r.rem) }))
      .filter((l) => l.qty > 0);
    if (!lines.length) {
      setMsg('Укажите, что грузим на машину.');
      return;
    }
    setBusy(true);
    setMsg(null);
    try {
      await shipTruck(ship.deal_id, { plate: plate.trim(), driver: driver.trim(), lines });
      onDone();
    } catch (e) {
      setMsg(e instanceof Error ? e.message : 'Не удалось отправить машину.');
      setBusy(false);
    }
  }

  return (
    <div className="ovl" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 520 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-h">
          <div className="grow">
            <div className="m-cli">🚚 Отправить машину на КПП</div>
            <div className="m-no">
              {ship.no} · {ship.client} · машина №{ship.trucks + 1}
            </div>
          </div>
          <button className="icon-btn close-x" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="mbody">
          {msg && <p className="err">{msg}</p>}
          <div style={{ display: 'flex', gap: 10 }}>
            <label className="fld" style={{ flex: 1 }}>
              <span className="fld-l">Номер авто</span>
              <input
                value={plate}
                disabled={busy}
                autoFocus
                placeholder="напр. 123 ABC 02"
                onChange={(e) => setPlate(e.target.value)}
              />
            </label>
            <label className="fld" style={{ flex: 1 }}>
              <span className="fld-l">Водитель / перевозчик</span>
              <input
                value={driver}
                disabled={busy}
                placeholder="напр. Иванов / ТК «Барыс»"
                onChange={(e) => setDriver(e.target.value)}
              />
            </label>
          </div>

          <div className="section-t" style={{ marginTop: 4 }}>
            Что грузим на эту машину
          </div>
          <div className="tablewrap glass">
            <table className="tbl card-table">
              <thead>
                <tr>
                  <th>Позиция</th>
                  <th className="r">Остаток</th>
                  <th className="r">На машину</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.id}>
                    <td data-label="Позиция">{r.name}</td>
                    <td data-label="Остаток" className="r mono muted">
                      {r.rem}
                    </td>
                    <td data-label="На машину" className="r">
                      {r.rem > 0 ? (
                        <input
                          type="number"
                          min="0"
                          max={r.rem}
                          style={{ width: 80, textAlign: 'right' }}
                          value={qty[r.id] ?? ''}
                          disabled={busy}
                          onChange={(e) => setQty((q) => ({ ...q, [r.id]: e.target.value }))}
                        />
                      ) : (
                        <span className="chip grn">✓</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div
            style={{
              display: 'flex',
              gap: 8,
              justifyContent: 'space-between',
              alignItems: 'center',
              marginTop: 12,
              flexWrap: 'wrap',
            }}
          >
            <span className="muted small">На машину: {totalLoad} ед.</span>
            <span style={{ display: 'flex', gap: 8 }}>
              <button
                className="btn ghost sm"
                disabled={busy}
                onClick={() => setQty(Object.fromEntries(rows.map((r) => [r.id, String(r.rem)])))}
              >
                Весь остаток
              </button>
              <button className="btn ghost sm" disabled={busy} onClick={onClose}>
                Отмена
              </button>
              <button className="btn sm" disabled={busy || totalLoad <= 0} onClick={submit}>
                {busy ? 'Отправляем…' : 'Отправить на КПП'}
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
